import styles from "./Subtitle.module.css";

const Subtitle = ({ textSubtitle }) => {
  return <h2 className={styles.containerText}>{textSubtitle}</h2>;
};

export default Subtitle;
